import { inject, Service } from '@angular/core';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';
import {Observable} from 'rxjs';
import {IecLeadTime} from '../model/iec-lead-time';

@Service()
export class LeadTimeService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'leadTime/';

  getSlowestLeadTime(): Observable<IecLeadTime> {
    const url = this.urlBase + 'slowest';
    return this.http.get<IecLeadTime>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  getConfigurationLeadTime(skus: string[]): Observable<IecLeadTime> {
    const url = this.urlBase + 'configuration';
    const body = JSON.stringify(skus);
    return this.http.post<IecLeadTime>(url, body, {headers: this.getPostHeaders('application/json')});
  }

  private getPostHeaders(contentType: string): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', contentType);
  }

  getLeadTimeByProgram(code: string): Observable<IecLeadTime> {
    const url = this.urlBase + 'byProgram/' + code;
    return this.http.get<IecLeadTime>(url, {headers: this.getRequestHeaders()});
  }

}
